<template>
  <chart-box @screen.once="showElement"
              title="Status Falhas nas Entregas"
              :isTitleCenter="true">
    <v-layout row wrap>
      <loading v-if="loading > 0" class="absolute-center" />

      <v-flex v-else md12 class="widget-legend px-5 pt-4 pb-2">
        <div v-if="hasData">
          <apexcharts width="100%"
                      height=300
                      type="bar"
                      :options="options"
                      :series="options.series"
                      class="legend-space-between" />
        </div>
        <empty-state v-else
                     size="75px"
                     class="fixed-center">
          No momento não há dados
        </empty-state>
      </v-flex>
    </v-layout>
  </chart-box>
</template>

<script>
  import ChartBox from './ChartBox'
  import Loading from '@/components/ui/Loading'
  import EmptyState from '@/components/ui/EmptyState'
  import chartMixin from '@/mixins/chart'

  export default {
    mixins: [ chartMixin ],
    components: { Loading, EmptyState, ChartBox },
    data () {
      return {
        loading: 0,
        hasData: false,
        options: {
          series: [{ data: [0, 0, 0] }],
          totalValue: 2379,
          labels: [],
          chart: {
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: { hideOverflowingLabels: false }
            }
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          title: { text: undefined },
          xaxis: {
            categories: [
              'Endereço inexistente',
              'CEP Incompleto',
              'Mudou-se'
            ],
            labels: { show: true },
            axisBorder: { show: true }
          },
          yaxis: {
            title: { text: undefined },
            labels: { show: true },
            axisBorder: { show: false }
          },
          fill: { opacity: 1 },
          dataLabels: {
            style: { fontSize: '14px' },
            dropShadow: {
              enabled: true,
              top: 1,
              left: 1,
              blur: 1,
              opacity: 0.25
            }
          },
          legend: { enabled: false },
          tooltip: { enabled: false },
          colors: [ this.$vuetify.theme.primary ],
          responsive: [{
            breakpoint: 599,
            options: {
              legend: { fontSize: '12px' }
            }
          }]
        }
      }
    }
  }
</script>
